import React, { useState, useRef } from 'react';
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Checkbox,
    FormControlLabel,
} from "@mui/material";
// import { Tooltip } from 'antd';
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { AiOutlineSearch } from "react-icons/ai";
import { Card, Alert } from "reactstrap";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import success from "../../assets/img/success.png";
import FileBase64 from "../../components/Upload/UploadFile";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchIcon from "@mui/icons-material/Search";
// import Tooltip from "@mui/material/Tooltip";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import failed from "../../assets/img/failed.png";
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import { makeStyles } from "@mui/styles";
import { AdminAddUpdateSMSProvider, resetAdminSMSProvider } from "../../redux/actions/addUpdateSmsProviderAdminAction";
import { resetGetSMSProvider, getSMSProvider } from "../../redux/actions/getSmsProviderAdminAction";
import { resetGetSMSProviderDropDown, getSMSProviderDropDown } from "../../redux/actions/getSmsProviderDropDownAdminAction";
import Util from "../../validation";
import val from "../../getThemeDetails";
const AdminSMSProvider = () => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [selectedSMSProvider, setselectedSMSProvider] = useState('');
    const [SmsProviderName, setSmsProviderName] = useState('');
    const [AddLanguageResp, setAddLanguageResp] = useState(false);
    const [respDescriptionAddUpdate, setrespDescriptionAddUpdate] = useState('');
    const [notificationOpen, setnotificationOpen] = useState(false);
    const [getLanguageListStatus, setGetLanguageListStatus] = useState(false);
    const [getLanguageListArray, setGetLanguageListArray] = useState("");
    const [addOpen, setAddOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [languageList, setLanguageList] = useState([])
    const [editOpen, seteditOpen] = useState(false);
    const [editBankId, setEditBankId] = useState('');
    const [editSMSProviderName, setSMSProviderName] = useState('');
    const [setAddUpdateResp, setsetAddUpdateResp] = useState(false);
    const [respDescriptionLanguageAddUpdate, setRespDescriptionLanguageAddUpdate] = useState('');

    // New state to manage regeneration attempts
    const [isRegeneratingToken, setIsRegeneratingToken] = useState(false);
    // Using a ref to track if the initial fetch has happened
    const initialFetchAttempted = useRef(false);

    const regenerateTokenRes = useSelector(({ regenerateToken }) => regenerateToken);
    // var authToken = regenerateTokenRes.data.AuthToken;
    const authToken = regenerateTokenRes.data?.AuthToken; // Use optional chaining for safety


    const adminAddUpdateSMSProviderList = useSelector(({ adminAddUpdateSMSProviderList }) => adminAddUpdateSMSProviderList);
    const adminGetSmsProviderSuccessListResponce = useSelector(({ adminGetSmsProviderSuccessList }) => adminGetSmsProviderSuccessList);
    const adminGetSmsProviderDropDownListRes = useSelector(({ adminGetSmsProviderDropDownList }) => adminGetSmsProviderDropDownList);


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const dispatch = useDispatch();
    const onInputChange = e => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === 'SmsProviderName') {
            Util.alphaNumeric(value) ? setSmsProviderName(value) : setSmsProviderName(SmsProviderName);
        }
        if (name === "selectedSMSProvider") {
            setselectedSMSProvider(value === "Select SMS Provider Name" ? "" : value);
        }

    }
    const handleNoticationClose = () => {
        setnotificationOpen(false);
        setRespDescriptionLanguageAddUpdate('');


    }
    const addLanguageModalOpen = () => {
        setAddOpen(true);
        setSmsProviderName('');

    }
    const handleClose = () => {
        setAddOpen(false);
    }
    const editHandleChange = e => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === 'editBankId') {
            setEditBankId(value);
        }
        if (name === 'editSMSProviderName') {
            Util.alphaNumeric(value) ? setSMSProviderName(value) : setSMSProviderName(editSMSProviderName);
        }

    }
    const editModal = (id, name) => {
        setEditBankId(id);
        setSMSProviderName(name);
        seteditOpen(true);
    }
    const closeEditModal = () => {
        seteditOpen(false);
    }

    const editSubmitReq = () => {
        setsetAddUpdateResp(true);
        const editReq = {
            actionCustomerMasterRequestVO: {

                id: editBankId,
                name: editSMSProviderName,

            }
        }
        dispatch(AdminAddUpdateSMSProvider(editReq, authToken));
        seteditOpen(false);
    }

    const addOrUpdateNewLanguageRespFunc = () => {
        if (setAddUpdateResp) {
            if (adminAddUpdateSMSProviderList.data.status === 'Success') {
                console.log(adminAddUpdateSMSProviderList, "adminAddUpdateSMSProviderListtttt")
                setRespDescriptionLanguageAddUpdate(adminAddUpdateSMSProviderList.data.description);
                setnotificationOpen(true);
                smsProviderListReq();

            }
            if (adminAddUpdateSMSProviderList.data.status === 'failed') {
                setRespDescriptionLanguageAddUpdate(adminAddUpdateSMSProviderList.data.description);
                setnotificationOpen(true);
                if (
                    adminAddUpdateSMSProviderList.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    adminAddUpdateSMSProviderList.data.description == "Authorization failed"
                ) {
                    console.log("nside auth failed", regenerateTokenRes.data.AuthToken);
                    console.log("inside auth failed", authToken);
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (adminAddUpdateSMSProviderList.data.status === 'Failed') {
                setRespDescriptionLanguageAddUpdate(adminAddUpdateSMSProviderList.data.description);
                setnotificationOpen(true);
                if (
                    adminAddUpdateSMSProviderList.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    adminAddUpdateSMSProviderList.data.description == "Authorization failed"
                ) {
                    console.log("nside auth failed", regenerateTokenRes.data.AuthToken);
                    console.log("inside auth failed", authToken);
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    }
    useEffect(() => {
        addOrUpdateNewLanguageRespFunc()
    }, [adminAddUpdateSMSProviderList.data.status]);


    // const getLanguageResp = () => {
    //     if (adminGetSmsProviderDropDownListRes.data.status === 'success') {
    //         setIsLoading(false);
    //         setLanguageList(adminGetSmsProviderDropDownListRes.data.smsProviderList);
    //     }
    //     if (adminGetSmsProviderDropDownListRes.data.status === 'failed') {
    //         if (
    //             adminGetSmsProviderDropDownListRes.data.description == "session out"
    //         ) {
    //             SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
    //         }
    //         if (
    //             adminGetSmsProviderDropDownListRes.data.description == "Authorization failed"
    //         ) {
    //             console.log("inside auth failed",regenerateTokenRes.data.AuthToken);
    //             console.log("inside auth failed",authToken);
    //             regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
    //         }
    //     }
    // }

    // useEffect(() => {
    //     getLanguageResp();
    // }, [adminGetSmsProviderDropDownListRes.data.status]);



    const addLanguageSubmitReq = () => {
        setAddLanguageResp(true);
        const addLangReq = {
            actionCustomerMasterRequestVO: {
                // adminId: regenerateTokenRes.data.partnerId,
                adminId: val.adminIDS,
                name: SmsProviderName,

            }
        }
        dispatch(AdminAddUpdateSMSProvider(addLangReq, authToken));
        setAddOpen(false)
    }

    const addSMSProviderNameResp = () => {
        if (AddLanguageResp) {
            if (adminAddUpdateSMSProviderList.data.status === 'success') {
                setRespDescriptionLanguageAddUpdate(adminAddUpdateSMSProviderList.data.description);
                setnotificationOpen(true);
                smsProviderListReq();
                smsProviderDropDownListReq();


            }
            if (adminAddUpdateSMSProviderList.data.status === 'failed') {
                setRespDescriptionLanguageAddUpdate(adminAddUpdateSMSProviderList.data.description);
                setnotificationOpen(true);
                if (
                    adminAddUpdateSMSProviderList.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    adminAddUpdateSMSProviderList.data.description == "Authorization failed"
                ) {
                    console.log("inside auth failed", regenerateTokenRes.data.AuthToken);
                    console.log("inside auth failed", authToken);
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    }
    useEffect(() => {
        addSMSProviderNameResp()
    }, [adminAddUpdateSMSProviderList.data.status]);


    const smsProviderListReq = () => {
        setIsLoading(true);
        setGetLanguageListStatus(true);

        let searchReq = {
            actionCustomerMasterRequestVO: {
                // adminId: regenerateTokenRes.data.partnerId,
                adminId: val.adminIDS,
                name: selectedSMSProvider,

            }
        }
        dispatch(getSMSProvider(searchReq, authToken));

    }

    // Effect to initially fetch SMS providers on component mount
    useEffect(() => {
        if (authToken) { // Ensure authToken is available before making the initial call
            smsProviderListReq(authToken);
        }
    }, [authToken]); // Dependency on authToken to ensure initial call or re-call after regeneration


    // Effect to handle the response of getSMSProvider
    useEffect(() => {
        if (adminGetSmsProviderDropDownListRes.data) {
            if (adminGetSmsProviderDropDownListRes.data.status === 'success') {
                setIsLoading(false);
                setLanguageList(adminGetSmsProviderDropDownListRes.data.smsProviderList || []);
                if (isRegeneratingToken) { // If we just finished regenerating and this was the retry
                    setIsRegeneratingToken(false); // Reset the flag
                }
            } else if (adminGetSmsProviderDropDownListRes.data.status === 'failed') {
                if (adminGetSmsProviderDropDownListRes.data.description === "session out") {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data?.partnerId);
                    if (isRegeneratingToken) {
                        setIsRegeneratingToken(false); // Reset flag on session out as well
                    }
                } else if (adminGetSmsProviderDropDownListRes.data.description === "Authorization failed") {
                    if (!isRegeneratingToken) { // Only regenerate if not already in progress
                        console.log("Authorization failed, regenerating token...");
                        setIsRegeneratingToken(true); // Set flag to true
                        regenerateToken(dispatch, regenerateTokenRes.data?.AuthToken, regenerateTokenRes.data?.partnerId);
                    } else {
                        console.log("Authorization failed, but token regeneration is already in progress or just occurred. Skipping re-regeneration.");
                        setIsLoading(false); // Stop loading if it's a persistent auth failure after regeneration attempt
                    }
                } else {
                    // Handle other failed statuses if necessary
                    setIsLoading(false);
                    console.error("Failed to get SMS providers:", adminGetSmsProviderDropDownListRes.data.description);
                    if (isRegeneratingToken) {
                        setIsRegeneratingToken(false); // Reset flag if failure isn't auth-related after regeneration
                    }
                }
            }
        }
    }, [adminGetSmsProviderDropDownListRes.data, dispatch, authToken, regenerateTokenRes.data?.partnerId, regenerateTokenRes.data?.AuthToken, isRegeneratingToken]);


    // useEffect(() => {
    //     smsProviderListReq();
    // }, [adminGetSmsProviderDropDownListRes.data.status]);

    const smsProviderDropDownListReq = () => {


        let searchReq = {
            actionCustomerMasterRequestVO: {
                // adminId: regenerateTokenRes.data.partnerId,
                adminId: val.adminIDS,
                name: "",

            }
        }
        dispatch(getSMSProviderDropDown(searchReq, authToken));

    }

    useEffect(() => {
        smsProviderDropDownListReq();
    }, []);





    const adminGetLanguageListFunc = () => {
        if (getLanguageListStatus) {
            console.log(getLanguageListStatus, "getLanguageListStatusssss20")
            if (adminGetSmsProviderSuccessListResponce.data.status == "success") {
                setGetLanguageListArray([].concat(adminGetSmsProviderSuccessListResponce.data.smsProviderList));
                setRespDescriptionLanguageAddUpdate(adminGetSmsProviderSuccessListResponce.data.description);
                setIsLoading(false);
                setPage(0);

            }
            if (adminGetSmsProviderSuccessListResponce.data.status == "failed") {
                setGetLanguageListArray(adminGetSmsProviderSuccessListResponce.data);
                setRespDescriptionLanguageAddUpdate(adminGetSmsProviderSuccessListResponce.data.description);
                setIsLoading(false);
                if (
                    adminGetSmsProviderSuccessListResponce.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    adminGetSmsProviderSuccessListResponce.data.description == "Authorization failed"
                ) {
                    console.log("nside auth failed", regenerateTokenRes.data.AuthToken);
                    console.log("inside auth failed", authToken);
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (adminGetSmsProviderSuccessListResponce.data.status == "NOT FOUND") {
                setRespDescriptionLanguageAddUpdate(adminGetSmsProviderSuccessListResponce.data.description);
                setGetLanguageListArray(adminGetSmsProviderSuccessListResponce.data)
                setIsLoading(false)
            }
        }
    }

    useEffect(() => {
        adminGetLanguageListFunc();
    }, [adminGetSmsProviderSuccessListResponce.data.status]);

    return (
        <>
            <Layout>
                <Card>
                    <Grid
                        container
                        style={{
                            padding: "20px",
                            display: "flex",
                            flexDirection: "row-reverse",
                        }}
                    >
                        <Grid item xs={12} md={3} sm={3} lg={3}>
                            <CustomButton
                                onClick={() => addLanguageModalOpen()}
                            >
                                Add SMS Provider
                            </CustomButton>
                        </Grid>

                    </Grid>

                    <Grid
                        container
                        spacing={2}
                        style={{ padding: "25px" }}
                    >
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                variant='standard'
                                label="SMS Provider Name"
                                fullWidth={true}
                                name="selectedSMSProvider"
                                value={selectedSMSProvider || ''}
                                onChange={onInputChange}
                            >
                                <MenuItem
                                    value="Select SMS Provider Name"
                                    selected="Select SMS Provider Name"
                                >
                                    Select SMS Provider Name
                                </MenuItem>
                                {adminGetSmsProviderDropDownListRes.data.smsProviderList &&
                                    [].concat(adminGetSmsProviderDropDownListRes.data.smsProviderList).map((x) => (
                                        <MenuItem key={x.id} value={x.name}>
                                            {x.name}
                                        </MenuItem>
                                    ))}
                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                    margin: "8px 8px"
                                }}
                                variant="contained"
                                onClick={smsProviderListReq}
                            >
                                Search
                                <SearchIcon style={{ marginLeft: "4px", fontSize: "21px" }} />
                            </CustomButton>
                        </Grid>
                    </Grid>
                </Card>
                {console.log(getLanguageListArray, "getLanguageListArrayyyyy")}
                {isLoading ? (
                    <LoadingSpinner />
                ) : getLanguageListArray.length == undefined ||
                    !getLanguageListStatus ? (
                    <Card>
                        <Grid
                            container
                            style={{
                                padding: "5px"
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography variant="body1" style={{ fontWeight: "700" }}
                                    className="themeText"

                                >
                                    Summary Data
                                </Typography>
                            </Grid>
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="my-2 tableHeaderColor"
                                    variant="secondary"
                                    style={{ color: "white" }}
                                >
                                    No Records Found!
                                </Alert>
                            </Grid>
                        </Grid>
                    </Card>
                ) : (
                    <div>
                        <Card>
                            <Grid
                                container
                                style={{
                                    padding: "10px"
                                }}
                            >
                                <Grid xs={12} sm={12} md={12} lg={12}>
                                    <Typography variant="body1" style={{ fontWeight: "700" }}
                                        className="themeText"

                                    >
                                        Report Table
                                    </Typography>
                                </Grid>
                                <TableContainer component={Paper} className="my-3">
                                    <Table
                                        size="small"
                                    // aria-label="a dense table"
                                    >
                                        <TableHead>
                                            <TableRow className="tableHeaderColor">
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    ID{" "}

                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    SMS Provider Name
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Action
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {getLanguageListArray &&
                                                []
                                                    .concat(getLanguageListArray)
                                                    .slice(
                                                        page * rowsPerPage,
                                                        page * rowsPerPage + rowsPerPage
                                                    )
                                                    .map((row, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell align="center">
                                                                {row.id}
                                                            </TableCell>
                                                            {/* <TableCell align="center">
                                                                {row.languageCode}
                                                            </TableCell> */}
                                                            <TableCell align="center">{row.name}</TableCell>
                                                            <TableCell align="center">
                                                                <CustomButton
                                                                    style={{
                                                                        padding: "8px"
                                                                    }}
                                                                    onClick={() => editModal(row.id, row.name)}
                                                                >
                                                                    <EditIcon style={{ color: "#fff" }} />
                                                                </CustomButton>
                                                            </TableCell>

                                                        </TableRow>
                                                    ))}
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25]}
                                        component="div"
                                        count={[].concat(getLanguageListArray).length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                    />
                                </TableContainer>
                            </Grid>
                        </Card>
                    </div>
                )}
            </Layout>


            <div>
                <Dialog open={addOpen} onClose={handleClose}>
                    <DialogTitle style={{ minWidth: "600px" }}>
                        Add SMS Provider Name
                    </DialogTitle>
                    <DialogContent>




                        <TextField
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            variant='standard'
                            type="text"
                            label="SMS Provider Name"
                            fullWidth={true}
                            name="SmsProviderName"
                            value={SmsProviderName || ""}
                            onChange={onInputChange}
                        ></TextField>

                    </DialogContent>
                    <DialogActions style={{ padding: "14px" }}>
                        <CustomButton
                            style={{
                                color: "white"
                            }}
                            variant="contained"
                            onClick={handleClose}
                        >
                            Cancel
                        </CustomButton>
                        <CustomButton
                            style={{
                                // backgroundColor: "#fff",
                                // color: "#000",
                                color: "white"
                            }}
                            variant="contained"
                            onClick={addLanguageSubmitReq}
                            disabled={!SmsProviderName}
                        >
                            Save
                        </CustomButton>
                    </DialogActions>
                </Dialog>
            </div>

            <div>
                <Dialog open={editOpen} onClose={closeEditModal}>
                    <DialogTitle style={{ minWidth: "600px" }}>
                        Edit SMS Provider
                    </DialogTitle>
                    <DialogContent>
                        {/* <TextField
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            disabled
                            color="primary"
                            type="text"
                            label="Id"
                            fullWidth={true}
                            name="editBankId"
                            value={editBankId || ""}
                            onChange={editHandleChange}
                        ></TextField> */}
                        {/* <TextField
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            type="text"
                            label="Language code"
                            fullWidth={true}
                            name="editLanguageCode"
                            value={editLanguageCode || ""}
                            onChange={editHandleChange}
                        ></TextField> */}
                        <TextField
                            required
                            style={{ marginTop: "10px", padding: "10px" }}
                            size="small"
                            color="primary"
                            type="text"
                            label="SMS Provider Name"
                            fullWidth={true}
                            name="editSMSProviderName"
                            value={editSMSProviderName || ""}
                            onChange={editHandleChange}
                        ></TextField>





                    </DialogContent>
                    <DialogActions style={{ padding: "14px" }}>
                        <CustomButton
                            style={{
                                // backgroundColor: "#fff",
                                // color: "#000",
                                color: "white"
                            }}
                            variant="contained"

                            onClick={closeEditModal}
                        >
                            Cancel
                        </CustomButton>
                        <CustomButton
                            style={{
                                // backgroundColor: "#fff",
                                // color: "#000",
                                color: "white"
                            }}
                            variant="contained"

                            onClick={editSubmitReq}
                        >
                            Save
                        </CustomButton>
                    </DialogActions>
                </Dialog>
            </div>


            {adminAddUpdateSMSProviderList.data.status == "success" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {adminAddUpdateSMSProviderList.data.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {adminAddUpdateSMSProviderList.data.status == "failed" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {adminAddUpdateSMSProviderList.data.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {adminAddUpdateSMSProviderList.data.status == "Success" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {adminAddUpdateSMSProviderList.data.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {adminAddUpdateSMSProviderList.data.status == "failed" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {adminAddUpdateSMSProviderList.data.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}


        </>
    )
}

export default AdminSMSProvider
